import type { iSupplierBillPaymentReceipt } from "@sdk/supplier-bill-payment-receipts/supplier-bill-payment-receipt-model";
import { CreateEntitySlice } from "../../utils/entity-slice-creator";
import { supplierBillPaymentReceiptsDefaultQueryConfig } from "./supplier-bill-payment-receipts-default-query";

export const {
  slice: SupplierBillPaymentReceiptsSlice,
  reducers: SupplierBillPaymentReceiptsSliceReducer,
  actions: {
    setEntityQueryResults: setSupplierBillPaymentReceiptsQueryResults,
    setEntity: setSupplierBillPaymentReceipt,
    setEntities: setSupplierBillPaymentReceipts,
    patchEntity: patchSupplierBillPaymentReceipt,
    addNewEntity: addNewSupplierBillPaymentReceipt,
    setEntityFetchingStatus: setSupplierBillPaymentReceiptFetchingStatus,
    setEntitiesFetchingStatus: setSupplierBillPaymentReceiptsFetchingStatus,
    setEntityFailedStatus: setSupplierBillPaymentReceiptFailedStatus,
    setEntityQueryError: setSupplierBillPaymentReceiptsQueryError,
    resetQuery: resetSupplierBillPaymentReceiptsQuery,
    setQueryList: setSupplierBillPaymentReceiptQueryList,
  },
} = CreateEntitySlice<iSupplierBillPaymentReceipt>({
  sliceName: "supplierBillPaymentReceipts",
  queryAliasResolver: (queryAlias: string) => {
    if (queryAlias === "all") {
      return {
        ...supplierBillPaymentReceiptsDefaultQueryConfig,
        alias: "all",
      };
    }
  },
});
